import { render, staticRenderFns } from "./RankingCell.vue?vue&type=template&id=2c5b220d"
import script from "./RankingCell.vue?vue&type=script&lang=js"
export * from "./RankingCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports